import React, { Fragment } from 'react';
import cn from 'classnames';
import {
  EmptyRow,
  TableRow,
  TableCell,
} from '../../../../../components/customTableComponents';
import CheckboxCell from '../../RequestsTable/components/CheckboxCell/CheckboxCell';
import styles from './TableRowsSkeleton.module.scss';

const Container = ({ bordered = false }) => {
  return (
    <div className={cn(styles.container, { [styles.bordered]: bordered })} />
  );
};

const TableRowsSkeleton = ({ pageSize }) => {
  const skeletons = new Array(pageSize).fill(null);

  const commonCellProps = {
    verticalAlign: 'center',
  };

  const cells = [
    { position: 'left' },
    { bordered: true },
    {},
    {},
    {},
    {},
    { position: 'right' },
  ];

  return skeletons.map((_, index) => (
    <Fragment key={index}>
      <EmptyRow />
      <TableRow>
        <CheckboxCell verticalAlign="top" disabled />
        {cells.map((cell, index) => (
          <TableCell {...commonCellProps} position={cell.position} key={index}>
            <Container bordered={cell.bordered ?? false} />
          </TableCell>
        ))}
      </TableRow>
    </Fragment>
  ));
};

export default TableRowsSkeleton;
